import React, { useState } from "react";
import VideoSavedSuccessfully from "./VideoSavedSuccessfully";
import VideoUploading from "./VideoUploading";
import VideoCancel from "./VideoCancel";
import VideoUploadedSuccess from "../../videoUpload/VideoUploadedSuccess";
import VideoUploadError from "../../videoUpload/VideoUploadError";

const FileUpload = ({ styleChange }) => {
  const [fileUploadStatus, setFileUploadStatus] = useState(0);
  return (
    <>
      {fileUploadStatus === 0 && (
        <VideoSavedSuccessfully
          statusVal={setFileUploadStatus}
          styleChange={styleChange}
        />
      )}
      {fileUploadStatus === 1 && (
        <VideoUploading
          statusVal={setFileUploadStatus}
          styleChange={styleChange}
        />
      )}
      {fileUploadStatus === 2 && (
        <VideoCancel
          statusVal={setFileUploadStatus}
          styleChange={styleChange}
        />
      )}
      {fileUploadStatus === 3 && (
        <VideoUploadedSuccess
          statusVal={setFileUploadStatus}
          styleChange={styleChange}
        />
      )}
      {fileUploadStatus === 4 && (
        <VideoUploadError
          statusVal={setFileUploadStatus}
          styleChange={styleChange}
        />
      )}
    </>
  );
};

export default FileUpload;
